import React, { useMemo } from "react";
import CarConfigBase from "./CarConfigBase";
import Summary from "./common/summary/Summary";
import Hero from "./configure-lbx/sections/atmosphere/subsections/Hero";
import HighlightsHero from "./highlights/sections/Hero";
import BackButton from "./common/header/BackButton";
import HeaderCta from "./common/header/Cta";
import HighlightsHeroButton from "./highlights/HighlightsHeroButton";
import { ComponentRegistryProvider } from "./componentRegistry";
import ConfigCtas from "./common/cta/ConfigCtas";
import OverviewItemWrapper from "./common/summary/overview/OverviewItemWrapper";

const CarConfig = (): JSX.Element => {
    const componentRegistry = useMemo(
        () => ({
            Summary,
            AtmosphereHero: Hero,
            HeaderCta,
            HeaderBackButton: BackButton,
            HighlightsHero,
            HighlightsHeroButton,
            ConfigCtas,
            OverviewItemWrapper,
        }),
        [],
    );
    return (
        <ComponentRegistryProvider registry={componentRegistry}>
            <CarConfigBase />
        </ComponentRegistryProvider>
    );
};

export default CarConfig;
